// routing
import RollOutProjectRouting from './roll-out-project/roll-out-project-routing';
import BatchOutProjectRouting from './batch-out-project/batch-out-project-routing';
import SignUpProjectRouting from './sign-up-project/sign-up-project-routing';
import BidCirculationProject from './bid-circulation-project/bid-circulation-routing.js';
import ContractedProjectRouting from './contracted-project/contracted-project-routing';

// component
import RouterView from '@/components/router-view.vue';

export default [
  {
    path: 'roll-out-project',
    component: RouterView,
    redirect: '/person-center/project/roll-out-project/list',
    meta: {
      title: '转出项目',
      breadCrumbShowIndexArr: [0, 1]
    },
    children: RollOutProjectRouting
  },
  {
    path: 'batch-out-project',
    component: RouterView,
    redirect: '/person-center/project/batch-out-project/list',
    meta: {
      title: '我的批量流转项目',
      breadCrumbShowIndexArr: [0, 1]
    },
    children: BatchOutProjectRouting
  },
  {
    path: 'sign-up-project',
    component: RouterView,
    redirect: '/person-center/project/sign-up-project',
    meta: {
      title: '报名流转标的',
      breadCrumbShowIndexArr: [0, 2]
    },
    children: SignUpProjectRouting
  },
  {
    path: 'bid-circulation-project',
    component: RouterView,
    redirect: '/person-center/project/bid-circulation-project',
    meta: {
      title: '竞价标的',
      breadCrumbShowIndexArr: [0, 2]
    },
    children: BidCirculationProject
  },
  {
    path: 'contracted-project',
    component: RouterView,
    redirect: '/person-center/project/contracted-project/list',
    meta: {
      title: '成交流转项目',
      breadCrumbShowIndexArr: [0, 2]
    },
    children: ContractedProjectRouting
  }
];

